
export enum AssetStateOfUse {
  Insufficient= 'Insufficient',
  WorkingAndMaintained= 'WorkingAndMaintained',
  LikeNew= 'LikeNew',

}